var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHouseIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor",
    viewBox: "0 0 20 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.035 8.4h15.93C18.5359 8.4 19 7.936 19 7.365a1.036 1.036 0 0 0-.1744-.5738L16.6994 3.602A1.344 1.344 0 0 0 15.5772 3H4.4228c-.45 0-.8719.225-1.1222.6019L1.1744 6.7884C1.0619 6.96 1 7.1597 1 7.3622 1 7.9359 1.464 8.4 2.035 8.4m.765.9v6.75c0 .7453.6047 1.35 1.35 1.35h6.3c.7453 0 1.35-.6047 1.35-1.35V9.3H10v4.5H4.6V9.3zm12.6 0v7.2c0 .4978.4022.9.9.9a.899.899 0 0 0 .9-.9V9.3z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHouseIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/house-icon.ca856320a3c315c2ec4966810ad9b9ce.svg";